export enum ClientStatus {
	IDLE = 'idle',
	LOADING = 'loading',
	STARTING = 'starting',
	READY = 'ready',
	ERROR = 'error'
}

export enum SlidingSyncListKey {
	SPACES = 'spaces',
	INVITES = 'invites',
	ROOMS = 'rooms'
}

export enum AsyncStatus {
	IDLE = 'idle',
	LOADING = 'loading',
	SUCCESS = 'success',
	ERROR = 'error'
}

export enum UploadStatus {
	IDLE = 'idle',
	LOADING = 'loading',
	SUCCESS = 'success',
	ERROR = 'error'
}

export enum BackupProgressStatus {
	IDLE = 'idle',
	FETCHING = 'fetching',
	LOADING = 'loading',
	DONE = 'done'
}
